import {AfterViewInit, computed, Directive, ElementRef, inject, input, OnDestroy, output} from '@angular/core';

@Directive({
  selector: '[msSelectFile]',
  exportAs: 'msSelectFile',
  standalone: true,
  host: {
    '(click)': 'onClick()',
  },
})
export class SelectFileDirective implements AfterViewInit, OnDestroy {
  private readonly elementRef = inject(ElementRef);

  readonly fileExtensions = input<string[]>([]);

  readonly multiple = input(true);

  readonly selectFile = output<FileList>();

  private fileInput: HTMLInputElement;

  private readonly accept = computed(() => {
    const extensions = this.fileExtensions();
    return extensions && extensions.length > 0 ? extensions.map(extension => `.${extension}`).join(',') : null;
  });

  ngAfterViewInit() {
    this.fileInput = document.createElement('input');
    this.fileInput.hidden = true;
    this.fileInput.type = 'file';
    this.fileInput.multiple = this.multiple();
    this.fileInput.setAttribute('test-id', 'ms-file-input');
    this.fileInput.addEventListener('change', event => {
      const target = event.target as HTMLInputElement;
      this.selectFile.emit(target.files);
      this.fileInput.value = '';
    });

    this.elementRef.nativeElement.appendChild(this.fileInput);
  }

  onClick() {
    this.fileInput.accept = this.accept();
    this.fileInput.click();
  }

  ngOnDestroy() {
    this.elementRef.nativeElement.removeChild(this.fileInput);
  }
}
